module.exports = __webpack_public_path__ + "public-roadmap-2-b-47ca8105d23b431bee50ed045ffc59e7.webp";